import React from "react";

function ProfitLossMonth({ datagetTrialBalanceReport ,selected_mode_table_structure,parentDetails}) {

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

  // Make sure data is always an array
  const data = Array.isArray(datagetTrialBalanceReport)
    ? datagetTrialBalanceReport
    : datagetTrialBalanceReport
    ? [datagetTrialBalanceReport]
    : [];

  // If still empty, show message
  if (!data.length) {
    return (
      <div className="min-h-screen bg-gray-200 py-10 px-4">
        <div className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-300 p-12 text-center text-gray-500 font-medium">
          No monthly data available for display.
        </div>
      </div>
    );
  }

  // Extract columns dynamically
  const columns = Object.keys(data[0] || {});

  return (
    <div className="min-h-screen bg-gray-200 py-10 px-4">
      <div className="max-w-8xl mx-auto bg-white shadow-xl rounded-none border border-gray-300 px-4 pt-4 pb-6 overflow-x-auto">
        
        {/* Header Title Banner */}
         <div>

                    <div style={{display:"flex", justifyContent:"center"}}>


                        {apiPaths_from_local_storage[0]?.REP_HEADER?.includes("data:image/") && (
                            <img style={{width:"60%"}}
                                src={apiPaths_from_local_storage[0].REP_HEADER}
                            />
                        )}

                    </div>

                    <div style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        color: '#0f172a',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        margin: '20px 0',
                        padding: '10px 16px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '6px'
                    }}>
                        {
                            selected_mode_table_structure.find(
                                (item) => item.mode_table_code === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_code
                            )?.mode_table_name
                        }
                    </div>

                </div>

        <table className="min-w-full divide-y divide-gray-200 text-sm mt-3">
          <thead className="border-b-2 border-gray-900">
            <tr>
              {columns.map((col, index) => {
                const isNumeric = typeof data[0][col] === "number";
                return (
                  <th
                    key={index}
                    className={`px-4 py-2 text-xs font-bold text-gray-900 uppercase tracking-wider ${
                      isNumeric ? "text-right" : "text-left"
                    }`}
                  >
                    {col}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map((row, i) => (
              <tr key={i} className="hover:bg-gray-50">
                {columns.map((col, j) => {
                  const val = row[col];
                  const isNumeric = typeof val === "number";

                  return (
                    <td
                      key={j}
                      className={`px-4 py-1.5 text-sm ${
                        isNumeric
                          ? "text-right tabular-nums font-mono text-gray-800"
                          : "text-left text-gray-700 font-medium"
                      }`}
                    >
                      {val !== null && val !== undefined
                        ? isNumeric
                          ? val.toFixed(2)
                          : val
                        : "-"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Report Footer */}
        <div className="mt-8">
          <div className="border-t-2 border-gray-900" />
          <div className="mt-0.5 border-t border-gray-300" />
          <div className="mt-4 flex justify-between items-center">
            <p className="text-xs text-gray-400">
              Generated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ProfitLossMonth;